import { useTranslation } from 'react-i18next'
import { Col } from 'web/components/layout/col'
import { Modal } from 'web/components/layout/modal'
import { BookmarkIcon } from '@heroicons/react/solid'
import clsx from 'clsx'

export const FollowMarketModal = (props: {
  open: boolean
  setOpen: (b: boolean) => void
  title?: string
}) => {
  const { open, setOpen, title } = props
  const { t } = useTranslation()
  return (
    <Modal open={open} setOpen={setOpen}>
      <Col className="bg-canvas-0 items-center gap-4 rounded-md px-8 py-6">
        <BookmarkIcon className={clsx('h-20 w-20')} aria-hidden="true" />
        <span className="text-xl">{title ? title : t('contract.followingQuestions')}</span>
        <Col className={'gap-2'}>
          <span className={'text-primary-700'}>• {t('contract.whatIsFollowing')}</span>
          <span className={'ml-2'}>
            {t('contract.followingDescription')}
          </span>
        </Col>
      </Col>
    </Modal>
  )
}
